// src/components/charts/KPICard.jsx
import React from 'react';
import { Card } from 'react-bootstrap';

/**
 * Componente KPI Card según diseño de Stoneweg
 * @param {Object} props
 * @param {String} props.title - Título del KPI
 * @param {String|Number} props.value - Valor principal
 * @param {String} props.subtitle - Subtítulo (ej: "Evol. Ingresos totales")
 * @param {String} props.icon - Emoji o icono
 * @param {String} props.iconBgColor - Color de fondo del icono
 * @param {Number} props.variation - Variación porcentual
 * @param {Boolean} props.isPositive - Si la variación es positiva
 * @param {Boolean} props.loading - Estado de carga
 * @param {Function} props.onClick - Handler para click
 */
const KPICard = ({
  title,
  value,
  subtitle,
  icon,
  iconBgColor = '#e0f2fe',
  variation,
  isPositive = true,
  loading = false,
  onClick,
}) => {
  return (
    <Card
      className="h-100 border-0 shadow-sm"
      style={{
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.2s ease',
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (onClick) {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)';
        }
      }}
    >
      <Card.Body className="p-3">
        {/* Header con título e icono */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div style={{ flex: 1 }}>
            <p className="text-muted mb-0 small fw-medium">{title}</p>
          </div>
          
          {icon && (
            <div
              className="d-flex align-items-center justify-content-center rounded"
              style={{
                width: '40px',
                height: '40px',
                backgroundColor: iconBgColor,
                fontSize: '1.5rem',
                flexShrink: 0,
              }}
            >
              {icon}
            </div>
          )}
        </div>

        {/* Valor principal */}
        {loading ? (
          <div className="d-flex justify-content-center py-3">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : (
          <>
            <h3 className="mb-2 fw-bold" style={{ fontSize: '1.75rem' }}>
              {value}
            </h3>

            {/* Subtítulo con variación */}
            <div className="d-flex align-items-center gap-2">
              {variation !== undefined && (
                <>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      fontSize: '18px',
                      color: isPositive ? '#10b981' : '#ef4444',
                    }}
                  >
                    {isPositive ? 'trending_up' : 'trending_down'}
                  </span>
                  <span
                    className="fw-semibold small"
                    style={{
                      color: isPositive ? '#10b981' : '#ef4444',
                    }}
                  >
                    {variation.toFixed(1)}%
                  </span>
                </>
              )}
              
              {subtitle && (
                <span className="text-muted small" style={{ fontSize: '0.8rem' }}>
                  {subtitle}
                </span>
              )}
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default KPICard;